// AEO/SEO answer content for the landing page. Written to be quotable by
// answer engines and to target the query family around "what ingredients".

export const homeFaq = [
  {
    question: "What ingredients are actually in the food I buy?",
    answer:
      "Most packaged food lists every ingredient by weight, but the names are chemical, abbreviated or grouped under umbrella terms like \u201cnatural flavors\u201d. InZoRAH reads that list from a barcode or label photo and rewrites it in plain English, telling you what each ingredient does, whether it matters for you, and which public record the answer came from.",
  },
  {
    question: "Is this ingredient safe?",
    answer:
      "That depends on the ingredient, the dose and on you. Rather than stamping ingredients \u201csafe\u201d or \u201cunsafe\u201d, InZoRAH shows what the public record actually says \u2014 what the ingredient is, how it is regulated, the amounts studied, and who has a real reason to avoid it \u2014 then flags it only if it clashes with the allergies, diet or skin concerns you set. Every ingredient in the A-Z glossary answers that question in one line at the top of its page.",
  },
  {
    question:
      "How do I find out what ingredients are in a product before I buy it?",
    answer:
      "Scan the barcode with InZoRAH. If the product is in a public database such as Open Food Facts or USDA FoodData Central, you get the full ingredient list and an explanation in seconds. If it is not, snap the label and the food ingredient scanner reads the printed ingredients directly.",
  },
  {
    question: "What ingredients should I avoid?",
    answer:
      "There is no single universal list. It depends on your allergies, your diet, your skin and what the evidence actually shows. InZoRAH lets you set allergies, diet and skin concerns, then flags only the ingredients that matter for you \u2014 and explains why, with a dated source.",
  },
  {
    question: "Where does InZoRAH get its ingredient information?",
    answer:
      "From public, checkable records: USDA FoodData Central, openFDA recalls and enforcement reports, Open Food Facts, and manufacturers\u2019 own published records. Every claim shows its source and date. If a fact cannot be verified, InZoRAH says so instead of guessing.",
  },
  {
    question:
      "Can InZoRAH tell me what ingredients are in skincare and supplements too?",
    answer:
      "Yes. The same scan works on food, drinks, supplements and skincare. For skincare it explains UV filters, preservatives and fragrance; for supplements it explains the active ingredients and the fillers around them.",
  },
  {
    question: "Is InZoRAH free, and when does it launch?",
    answer:
      "The app is coming to the App Store and Google Play, with a free plan of 12 scans a month and optional Premium at $4.99 a month. The launch date will be announced on this page and on the ingredient blog.",
  },
  {
    question: "Is an ingredient scan the same as medical advice?",
    answer:
      "No. InZoRAH is educational information only, not medical, nutritional or dermatological advice. If you have an allergy, always read the physical label on the package, including the \u201cmay contain\u201d statement.",
  },
];

export const answerBlock = {
  heading: "What ingredients are in the things you eat, drink and wear?",
  answer:
    "An ingredient list tells you everything in a product, in order of weight \u2014 but almost nobody can decode it in the aisle. InZoRAH is an ingredient checker you point at the shelf: scan the barcode or the label and the ingredient analyzer explains what is inside in plain English, ties every claim to a public source such as USDA FoodData Central, openFDA or Open Food Facts, and then points you to a cleaner product beside it.",
  points: [
    {
      term: "Food and drink",
      text: "Added sugars, sweeteners, emulsifiers, preservatives, colours and \u201cnatural flavors\u201d, explained with amounts where the record exists.",
    },
    {
      term: "Supplements",
      text: "What the active ingredients are, what the fillers do, and where the label goes further than the evidence.",
    },
    {
      term: "Skincare and personal care",
      text: "UV filters, preservatives, fragrance and actives \u2014 matched against the skin concerns you set.",
    },
    {
      term: "Allergens and recalls",
      text: "Allergen names in disguise, plus openFDA recall matches on the products you keep.",
    },
  ],
};
